import React, { Component } from 'react';

import { Link } from 'react-router-dom';

class SelectType extends Component {
  render() {
    return(
      <div className="container-fluid content-wrapper registration-bg-image">
          <div className="row">
              <div className="container">
                <div className="row" id="registration">
                  <div className="col-12 col-md-6 join-title  pad-md-t-lg pad-md-b-lg pad-lg-t-40 pad-xs-t-lg pad-lg-b-lg xs-h400 md-hauto">
                    <h1 className="title-common primary padBottom join-now-title">Join Now</h1>
                    <p className="title-description">Its free. Get access to unique FirstNet APIs, create apps and distribute them to millions of public safety professionals.</p>
                  </div>
                  <div className="col-12">
                    <div className="row padTop padBottom registration-account-detail">
                      <div className="col-12 col-md-6">
                        <div className="row account-detail-info h-100">
                          <div className="col-12">
                            <h2>Create an Organization Account</h2>
                          </div>
                          <div className="col-12 account-detail-description">
                            <p>For teams: add and manage multiple users, and work on apps together.</p>
                          </div>
                          <div className="col-12 text-right">
                            <Link to='/corporate' target="_self">GET STARTED <i className="fa fa-chevron-circle-right"></i></Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="row account-detail-info h-100">
                          <div className="col-12">
                            <h2>Create an Individual Account</h2>
                          </div>
                          <div className="col-12 account-detail-description">
                            <p>For solo developers: your workspace and apps can not be shared with other users.</p>
                          </div>
                          <div className="col-12 text-right">
                            <Link to='/individual'>GET STARTED <i className="fa fa-chevron-circle-right"></i></Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
    )
  }
}

export default SelectType;



// WEBPACK FOOTER //
// ./src/registration/SelectType.js